import React, { Component, Fragment } from 'react';
import axios from 'axios';

import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';


import withStyles from '@mui/styles/withStyles';
import Button from '@mui/material/Button';
import Autocomplete from '@mui/material/Autocomplete';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import Grid from '@mui/material/Grid';

import styles from "../styles";
import PageHeader from "../helper/PageHeader";
import DeleteDialog from '../helper/Dialogs';

import { authContext } from "../../context/AuthContext";

class GeoGroup extends Component {
    static contextType = authContext;

    constructor(props) {
        super(props);

        this.counties = [];

        // axios.get('/api/stateCounty/county/FL', {})
        //     .then(res => {
        //         res.data.map((u) =>
        //             this.counties.push({ label: u.stateCountyName, value: u.stateCountyName })
        //         );
        //     }).catch(error => {
        //         console.log("error:" + error);
        //     });
        this.state = {
            id: this.props.match.params.id,
            name: '',
            administrator: '',
            members: [],
            membersOther: [],
            county: '',
            isDeleteDialogOpen: false,
            itemToDelete: '',
            filteredCounties: [],
            allMembers: []
        }
    }

    handleDeleteDialogOpen = () => {
        this.setState({ isDeleteDialogOpen: true });
    };

    handleDeleteDialogClose = () => {
        this.setState({ isDeleteDialogOpen: false });
    };

    validate = (event) => {
        let addForm = document.querySelector("#form");
        addForm.reportValidity();
        if (addForm.checkValidity() === false) {
            return false;
        }
        return true;
    }

    updateListCounties = () => {
        let countiesFilter = [];
        axios.get('/api/stateCounty/county/FL')
        .then(res => {
            res.data.forEach((u) =>
            {
            //  console.log("other counties", this.state.membersOther);
            //  console.log("counties", this.state.members);
                if( (!this.state.members.includes(u.stateCountyName)) && (!this.state.membersOther.includes(u.stateCountyName)) && (!this.state.allMembers.includes(u.stateCountyName))  ) {
                    countiesFilter.push({ label: u.stateCountyName, value: u.stateCountyName })
                }
            }            
            );
        }).catch(error => {
            console.log("error:" + error);
        });
        this.setState({
            filteredCounties: countiesFilter
        });
    }

    onAddCounty = (event) => {
        let membercounties = this.state.members;
        let otherMemberCounties = this.state.membersOther;
        console.log('other', otherMemberCounties);
        if (membercounties.includes(this.state.county.value) || otherMemberCounties.includes(this.state.county.value)  ) return;

        membercounties.push(this.state.county.value);
        this.setState({
            members: membercounties,
        });

        this.updateListCounties();

    }

    onDeleteCounty = (event) => {
        // let county = event.currentTarget.getAttribute('data-tag');
        this.handleDeleteDialogClose();
        let county = this.state.itemToDelete;
        this.setState({ itemToDelete: '' });

        let membercounties = this.state.members;

        var index = membercounties.indexOf(county);
        if (index > -1) {
            membercounties.splice(index, 1);
        }

        this.setState({
            members: membercounties
        });
    }

    onSave = (event) => {
        // if (!this.state.members || this.state.name || this.state.county) return;
        let token = sessionStorage.getItem('accessToken');

        var url = "/api/geoGroup";
        if (this.state.id !== undefined) {
            url = url + '/' + this.state.id;
        }

        var data = {
            name: this.state.name,
            members: this.state.members,
        }
        axios(url, 
            {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            data})
        .then(response => {
            console.log("response: " + response);
            if (response.status >= 400) {
                throw new Error(response.statusText);
            }
            this.props.history.goBack();
        });
    }

    handleChange = event => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    handleCountyChange = (event, value) => {
        let selected = value;
        if (selected === null) {
            this.setState({
                county: ''
            })
            return;
        }

        this.setState({ county: JSON.parse(JSON.stringify(selected)) });
    }

    componentDidMount() {

        if (this.props.match.params.id !== undefined) {
            

            axios.get('/api/geoGroup/' + this.props.match.params.id, {
            }).then((res) => {
                console.log('res data name, admin, members', res.data);
                let counties = res.data.members.map(m => {
                    return m.county;
                })
                this.setState({
                    name: res.data.name,
                    administrator: res.data.administrator,
                    members: counties
                });
                this.updateListCounties();
            }).catch(error => {
                console.log("error:" + error);
            });

            let allGroups = [];

        axios.get('/api/geoGroup')
            .then(res => {
                console.log('res', res.data.geogroups);
                allGroups = res.data.geogroups.map(m =>{
                    return m.ID;
                })
                console.log('allgroups', allGroups);
                for(let i =0; i< allGroups.length;i++){
                   
                    if(this.props.match.params.id !== allGroups[i]){
                        axios.get('/api/geoGroup/' + allGroups[i], {
                        }).then((res) => {
                            console.log(res.data);
                            let counties = res.data.members.map(m => {
                                return m.county;
                            })
                            this.setState({
                                membersOther: counties
                            });
                            console.log("counties", this.state.members);
                            console.log("others from other", this.state.membersOther);
                            //updating the list of counties that can be added
                            this.updateListCounties();
                            
                        }).catch(error => {
                            console.log("error:" + error);
                        });
                    }
                    
                }
            }
                )
            .catch(error => {
                console.log("error:" + error);
            });

            

           //  console.log("other counties", this.state.membersOther);
           //  console.log("counties", this.state.members);
            

        } else {
            console.log("filteredCounties", this.state.filteredCounties);

            let allGroups = [];

            axios.get('/api/geoGroup', {})
            .then(res => {
                console.log('res', res.data.geogroups);
                allGroups = res.data.geogroups.map(m =>{
                    return m.ID;
                })
                console.log('allgroups', allGroups);
                for(let i =0; i< allGroups.length;i++){
                
                        axios.get('/api/geoGroup/' + allGroups[i], {
                        }).then((res) => {
                            console.log(res.data);
                            let counties = res.data.members.map(m => {
                                return m.county;
                            })
                            this.setState({
                                allMembers: [...this.state.allMembers, ...counties]
                            });
                            console.log("counties", this.state.allMembers);
                            
                        }).catch(error => {
                            console.log("error:" + error);
                        });
                    
                    
                }
                let countiesFilter = [];
        axios.get('/api/stateCounty/county/FL', {})
        .then(res => {
            res.data.forEach((u) =>
            {
            //  console.log("other counties", this.state.membersOther);
            //  console.log("counties", this.state.members);
                if( (!this.state.allMembers.includes(u.stateCountyName)) ) {
                    countiesFilter.push({ label: u.stateCountyName, value: u.stateCountyName })
                }
            }            
            );
        }).catch(error => {
            console.log("error:" + error);
        });
        this.setState({
            filteredCounties: countiesFilter
        });
            }
                )
            .catch(error => {
                console.log("error:" + error);
            });

            this.setState({
                id: undefined,
                name: '',
                administrator: '',
                members: []
            });
        }
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state,callback)=>{
            return;
        };
    }

    render() {
        const { classes } = this.props;
        const disableAction = this.context.roles.isClassroomTrainingAdmin === 1? false:true;

        return (
            <Fragment>
                <PageHeader
                    title={"Region"}
                    cancel={this.props.history.goBack}
                    actionButtons={[{ label: "Save", action: this.onSave, disabled: this.state.members.length === 0 || disableAction }]}
                />

                <ValidatorForm
                    noValidate
                    onSubmit={this.onAddCounty}
                >
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={5}>
                            <TextValidator
                                label="Region Name"
                                type="text"
                                name='name'
                                value={this.state.name}
                                className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                validators={['required']}
                                errorMessages={['Region name is required']}
                                fullWidth
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={5}>
                            <Autocomplete
                                id="county"
                                options={this.state.filteredCounties}
                                getOptionLabel={(option) => option.label}
                                isOptionEqualToValue={(option, value) => option.value === value.value }
                                value={this.state.county || null }
                                onChange={this.handleCountyChange}
                                className={[classes.autoComplete].join(' ')}
                                renderInput={(params) => <TextValidator {...params}
                                    label="County"
                                    validators={['required']}
                                    errorMessages={['County is required']}
                                    value={this.state.county}
                                    required
                                />}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2} style={{ textAlign: "center", alignSelf: "flex-end" }}>
                            <Button variant="contained" color="primary" className={[].join(' ')} type="submit" disabled = {disableAction} >Add</Button>
                        </Grid>
                    </Grid>

                    <br /><br />

                    <TableContainer component={Paper}>
                        <Table className={classes.table} aria-label="geogroup table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Region</TableCell>
                                    <TableCell>County</TableCell>
                                    <TableCell>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.members.map((p) => (
                                    <TableRow key={p}>
                                        <TableCell component="th" scope="row">
                                            {this.state.name}
                                        </TableCell>
                                        <TableCell>
                                            {p}
                                        </TableCell>
                                        <TableCell align="center">
                                            <IconButton
                                                aria-label="delete"
                                                data-tag={p}
                                                className={[classes.deleteButton].join(' ')}
                                                disabled={disableAction}
                                                onClick={() => {
                                                    this.setState({ itemToDelete: p });
                                                    this.handleDeleteDialogOpen();
                                                }}
                                                size="large">
                                                <DeleteIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <DeleteDialog
                        open={this.state.isDeleteDialogOpen}
                        onClose={this.handleDeleteDialogClose}
                        onDelete={this.onDeleteCounty}
                    />
                </ValidatorForm>
            </Fragment >
        );
    }
}

// export default GeoGroup;
export default withStyles(styles, { withTheme: true })(GeoGroup);
